module.exports = __webpack_public_path__ + "img/banner.be50f758.png";